import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import ToggleMenu from 'modules/_shared/components/ToggleMenu';
import { Document } from 'types';
import { getDocumentIcon } from 'utils/documentIcons';
import { format } from 'date-fns';
import { dateFormat } from 'constants/formats';
import { formatFileSize } from 'utils/formatFileSize';
import Swal from 'sweetalert2';
import deleteDocument from 'utils/deleteDocument';
import downloadFile from 'utils/downloadFile';

type DocumentRowProps = {
  index: number;
  document: Document;
};

const DefaultListRow: FC<DocumentRowProps> = ({ index, document }) => {
  const { t } = useTranslate();

  const handleView = () => {
    downloadFile({ documentId: document._id });
  };
  const handleDownload = () => {};
  const handleDelete = () => {};

  const icon = getDocumentIcon(document);
  const size = formatFileSize(document?.size || 0);

  const toggleOptions = [
    <a
      className="d-flex cursor-pointer"
      key={`doc-view-${index}`}
      onClick={handleView}
    >
      <em className="icon ni ni-eye fs-20px" />
      <span className="ml-1">{t('View')}</span>
    </a>,
    // <a
    //   className="d-flex cursor-pointer"
    //   key={`doc-download-${index}`}
    //   onClick={handleDownload}
    // >
    //   <em className="icon ni ni-download fs-20px" />
    //   <span className="ml-1">{t('Download')}</span>
    // </a>,
    // <a
    //   className="d-flex cursor-pointer"
    //   key={`doc-delete-${index}`}
    //   onClick={handleDelete}
    // >
    //   <em className="icon ni ni-trash fs-20px" />
    //   <span className="ml-1">{t('Delete')}</span>
    // </a>,
  ];

  return (
    <div className="doc-row" onClick={handleView}>
      <span className="doc-row__icon">
        <img src={icon} alt={document.fileType} width={36} height={36} />
      </span>
      <div className="doc-row__info">
        <span className="doc-row__name">{document.name}</span>
        {document.description && (
          <span className="doc-row__subtitle">{document.description}</span>
        )}
      </div>
      <span className="doc-row__date">
        {document.date ? format(new Date(document.date), dateFormat) : '-'}
      </span>
      <span className="doc-row__size">{size}</span>
      <div className="doc-row__more-btn" onClick={(e) => e.stopPropagation()}>
        <ToggleMenu toggleOptions={toggleOptions} />
      </div>
    </div>
  );
};

export default DefaultListRow;
